import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate } from '@angular/animations';
import { HomeVideoService } from '@shared/services/home-video-service/home-video.service';

@Component({
  selector: 'home-video-modal',
  templateUrl: './home-video-modal.component.html',
  styleUrls: ['./home-video-modal.component.scss']
  // animations: [
  //   trigger('openClose', [
  //     transition(':enter', [animate('200ms ease-in')]),
  //     transition(':leave', [animate('200ms ease-in')])
  //   ])
  // ]
})
export class HomeVideoModalComponent implements OnInit {

  constructor(private _homeVideo: HomeVideoService) { }

  ngOnInit() {
  }

  close() {
    this._homeVideo.toggle();
  }

}
